import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, successLabel: String }
  static targets = ["label"]

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = this.successLabelValue
      setTimeout(() => { this.labelTarget.textContent = original }, 2000)
    })
  }
}
